// src/components/Footer.jsx

import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 bg-black mt-auto">
      <div className="max-w-6xl mx-auto px-5 py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">

          {/* Brand */}
          <div>
            <p className="text-white font-semibold text-sm">Gametrait</p>
            <p className="text-zinc-600 text-xs mt-0.5">
              &copy; {new Date().getFullYear()} Gametrait. All rights reserved.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link
              to="/about"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              About
            </Link>
            <Link
              to="/privacy-policy"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/children-privacy"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              Children&apos;s Privacy
            </Link>
            <a
              href="mailto:hello@gametrait.com"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              Contact Us
            </a>
            <a
              href="https://instagram.com/gametraitfootball"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-white text-xs transition-colors"
            >
              Instagram
            </a>
            {/* Required for Apple App Store UGC compliance */}
            <a
              href="mailto:hello@gametrait.com?subject=Report%20Content&body=Please%20describe%20the%20content%20you%20are%20reporting%3A"
              className="text-zinc-500 hover:text-red-400 text-xs transition-colors"
            >
              Report Content
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
